import mobileMenu from './mobileMenu.vue'

const Plugin = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }
    this.installed = true
    this.event = new Vue()

    Vue.component(mobileMenu.name, mobileMenu)
    // Vue.mixin({
    // })

    Vue.prototype.$mobileMenu = {
      toggle (bool) {
        Plugin.event.$emit('toggle', bool)
      },
      set (options) {
        Plugin.event.$emit('set', options)
      },
      focus (target) {
        Plugin.event.$emit('focus', target)
      }
    }
  }
}

// This exports the plugin object.
export default Plugin
